import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/staffingOverview",
      name: "staffingOverview",
      meta: { requiresAuth: true, title: "routes.staffingOverview" },
      component: () => import("./main.vue")
    }
  ]
};
